import '../../Styles/socialSharing.scss';

await import("shariff");

window.am = window.am || {}

window.am.shariff = new function () {
    var that = this;

    that.init = function () {

        var buttonsContainer = document.querySelectorAll("[class^=shariff]")

        for (let i = 0; i < buttonsContainer.length; i++) {
            new Shariff(buttonsContainer[i], {

            });
        }

        var fasIcons = document.querySelectorAll(".fas");
        var fabIcons = document.querySelectorAll(".fab");
        var fontIcons = ["icons-facebook2", "icons-twitter2", "icons-xing2", "icons-whatsapp", "icons-linkedin-full"];

        for (let i = 0; i < fasIcons.length; i++) {
            fasIcons[i].className = "";
            fasIcons[i].classList.add("icon");
            fasIcons[i].classList.add("icons-kontakt");
        }

        for (let i = 0; i < fabIcons.length; i++) {
            var index = i % 5;
            fabIcons[i].className = "";
            fabIcons[i].classList.add("icon");
            fabIcons[i].classList.add(fontIcons[index]);
        }
    }
}

window.am.shariff.init()